<template>
  <component
    class="button"
    :is="tag"
    :href="href"
    :disabled="disabled"
    @click.prevent="$emit('click')"
  >
    {{ label }}
  </component>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    label: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: 'button',
      validator: (prop) => [
        'button',
        'a',
      ].includes(prop),
    },
    href: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.button {
  display: inline-block;
  padding: var(--unit-extra-small);
  border-radius: var(--token-border-radius-small);
  border: var(--unit-extra-small) solid transparent;
  background-color: var(--token-color-fill-light);
  outline: none;
}

.button:hover {
  box-shadow: var(--token-glow);
}

.button:focus,
.button:active {
  background-color: var(--token-color-fill-highlighted);
  box-shadow: var(--token-glow-highlighted);
}

a.button {
  text-decoration: none;
  color: inherit;
}
</style>
